export class Padding {
    left: number;
    right: number;
    top: number;
    bottom: number;

    constructor(p: number);
    constructor(horizontal: number, vertical: number);
    constructor(p1: number, p2?: number) {
        if (p2 === undefined) {
            this.left = this.right = this.top = this.bottom = p1;
        } else {
            this.left = this.right = p1;
            this.top = this.bottom = p2;
        }
    }
}